import "./Extrajudicial.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import WaterInIslamicPerspective from "./sections/WaterInIslamicPerspective";
import StudentServicesDetails from "./sections/StudentServicesDetails";
import PayrollInquiries from "./sections/PayrollInquiries";
import Footer from "@/reusable_sections/Footer";
export default function ExtrajudicialPage() {
  return <div>
      <GatewayNavigation />
      <WaterInIslamicPerspective />
      <StudentServicesDetails />
      <PayrollInquiries />
      <Footer />
    </div>;
}